import React from 'react';
import HeroSection from '../../../components/sections/HeroSection';
import FactsAndStatsSection from '../../../components/sections/FactsAndStatsSection';
import FaqAccordionsSection from '../../../components/sections/FaqAccordionsSection';
import FooterSection from '../../../components/sections/FooterSection';
import ParallaxCallSection from '../../../components/sections/ParallaxCallSection';
import BigTinyIntroSection from '../../../components/sections/BigTinyIntroSection';

function VisaStudyOverviewPage(props) {
    React.useEffect(() => {
        if (window.UIkit !== undefined) {
            window.UIkit.update();
        }
    }, []);

    const partners = [
        {
            "id": "nu",
            "name": "Nazarbayev University",
            "logoUrl": "https://static.tildacdn.pro/tild3863-3038-4632-b365-363362373130/NU_horizontal_1.png",
            "websiteUrl": "https://nu.edu.kz/admissions",
            "description": "A world-class research university in Astana, partnering with leading global institutions to provide a Western-style education and foster innovation."
        },
        {
            "id": "coventry",
            "name": "Coventry University Astana",
            "logoUrl": "https://i.namu.wiki/i/0d5H8vxTBEVR9kj2fPyKjZEMOFlxDSTNguyY4AYvaHiK75rS8_WoiWEeH9uZvApfKwxfLg-tRbJDm_m0P1Wrig.webp",
            "websiteUrl": "https://www.coventry.ac.uk/kazakhstan/astana/",
            "description": "A UK-based university with a campus in Astana, offering a range of undergraduate courses with British educational standards."
        },
        {
            "id": "abu",
            "name": "Alikhan Bokeikhan University",
            "logoUrl": "https://abu.edu.kz/_next/image?url=https%3A%2F%2Fback.abu.edu.kz%2Fuploads%2Fen_1761132598325-727354414.png&w=3840&q=75",
            "websiteUrl": "https://abu.edu.kz/",
            "description": "A modern, multidisciplinary university in Kazakhstan, offering a wide array of programs and focusing on student success."
        },
        {
            "id": "aitu",
            "name": "Astana IT University",
            "logoUrl": "https://static.tildacdn.pro/tild3764-6633-4663-b138-303730646233/aitu-logo__2.png",
            "websiteUrl": "https://astanait.edu.kz/",
            "description": "A leading institution for information technology education, preparing specialists for the digital economy in a state-of-the-art campus."
        },
        {
            "id": "enu",
            "name": "L.N. Gumilyov Eurasian National University",
            "logoUrl": "https://enu.kz/v1/smartapi/serve?path=/general/files/393979c3-6d62-4658-8892-e87ac7569357.png",
            "websiteUrl": "https://enu.kz/",
            "description": "One of Kazakhstan's leading classical universities, known for its strong research base and diverse academic offerings."
        }
    ];

    const faqItems = [
        {
            question: "What is the C9 Student Visa?",
            answer: "The C9 visa is the official category for foreign nationals entering Kazakhstan for educational purposes, including university studies, exchange programs, and preparatory courses. It can be issued for single entry (up to 90 days) or multiple entries (up to one year), depending on the study duration. We handle the entire application process for you."
        },
        {
            question: "Can I work while studying in Kazakhstan?",
            answer: "Generally, a C9 student visa does not permit formal employment. However, some universities may offer on-campus job opportunities or internships as part of the curriculum. It's crucial to check with your university's international office for specific rules and regulations."
        },
        {
            question: "Are there scholarships available for international students?",
            answer: "Yes! The government of Kazakhstan offers state-funded scholarships to attract talented international students. For the 2025-2026 academic year, 550 scholarships were approved. Our team can help you identify and apply for these competitive opportunities to lower your financial barriers."
        },
        {
            question: "What happens after I receive my admission letter?",
            answer: "Once you have the official admission letter, we will guide you through the C9 visa application, including document preparation and submission to the Kazakhstani embassy in your country. After your visa is approved and you arrive, we assist with mandatory migration registration to ensure you are fully compliant with local laws."
        }
    ];

    const stats = {
        stat1: "624k+",
        fact1: "Total Students in Higher Education",
        stat2: "31.5k+",
        fact2: "International Students & Growing",
        stat3: "550+",
        fact3: "State Scholarships for Foreigners (2025-26)",
        stat4: "150k",
        fact4: "Gov. Target for Foreign Students by 2029",
    };

    return (
        <div>
            <HeroSection
                isExpectingAnimations={true}
                title="Your Gateway to a World-Class Education in Kazakhstan"
                paragraph="Join thousands of international students choosing Kazakhstan for its modern universities, affordable tuition, and vibrant culture. Jai International is your dedicated partner for a seamless journey from application to arrival."
                callToAction="Start Your Application"
                backgroundImageUrl="/imgvideo/astana_hd.jpg"
                onCallToActionClick={() => window.open("https://wa.me/77750912804?text=Hello%2C%20I%20want%20to%20study%20in%20Kazakhstan", "_blank")}
                callToActionButtonClass="uk-button-jai"
            />

            <div>
                <div className="uk-section">
                    <BigTinyIntroSection
                        centered={false}
                        Big="Unlock Your Future in the Heart of Eurasia. Kazakhstan is not just emerging; it's strategically positioning itself as a vibrant educational hub. With a government-backed vision for internationalization, the nation is blending its rich Eastern heritage with world-class academic standards to create a unique and compelling offer for students worldwide."
                        Tiny="At Jai International, we specialize in turning your dream of studying here into a reality. We provide comprehensive guidance, from choosing the right university among our esteemed partners to securing your C9 student visa, ensuring you have the best options for your academic and career ambitions."
                    />
                </div>

                <FactsAndStatsSection
                    sectionTitle="Kazakhstani Education by the Numbers"
                    {...stats}
                />

                <div className="uk-section uk-container">
                    <h2 className="uk-h2 uk-text-bold uk-text-center">Why Study in Kazakhstan?</h2>
                    <p className="uk-text-lead uk-text-center">Discover a country that's investing heavily in becoming a regional leader for higher education.</p>
                    <div className="uk-child-width-1-3@m uk-grid-match uk-margin-medium-top" data-uk-grid>
                        <div>
                            <div className="uk-card uk-card-body uk-text-center">
                                <span data-uk-icon="icon: world; ratio: 3" className="uk-text-primary"></span>
                                <h3 className="uk-card-title uk-margin-top">Globally Recognized Education</h3>
                                <p>Kazakhstani universities are making their mark, entering prestigious global rankings like the Times Higher Education (THE) Top 500 and the QS Asia top 100-200. This reflects measurable improvements in research, teaching, and international outlook, ensuring your degree holds weight globally.</p>
                            </div>
                        </div>
                        <div>
                            <div className="uk-card uk-card-body uk-text-center">
                                <span data-uk-icon="icon: star; ratio: 3" className="uk-text-primary"></span>
                                <h3 className="uk-card-title uk-margin-top">Affordable & High-Value</h3>
                                <p>Enjoy a high standard of living and quality education at a fraction of the cost of Western countries. Your investment goes further, allowing you to focus on your studies and cultural immersion without financial strain.</p>
                            </div>
                        </div>
                        <div>
                            <div className="uk-card uk-card-body uk-text-center">
                                <span data-uk-icon="icon: users; ratio: 3" className="uk-text-primary"></span>
                                <h3 className="uk-card-title uk-margin-top">Rich Cultural Experience</h3>
                                <p>Immerse yourself in a unique culture where modern cityscapes meet ancient traditions. From the steppes to the mountains, explore stunning landscapes and engage with a welcoming, multicultural society at the crossroads of Asia and Europe.</p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="uk-section uk-container">
                    <div className="uk-container">
                        <h2 className="uk-h2 uk-text-bold uk-text-center">A Commitment to Global Education</h2>
                        <p className="uk-text-lead uk-text-center">Kazakhstan's government is actively fostering an international academic environment through strategic initiatives.</p>
                        <div className="uk-child-width-1-3@m uk-grid-match uk-margin-medium-top" data-uk-grid>
                            <div>
                                <div className="uk-card uk-card-body">
                                    <h3 className="uk-card-title">Ambitious Growth Targets</h3>
                                    <p>The government has set a clear goal to attract 150,000 international students by 2029. This policy is driving universities to expand English-taught programs, enhance campus facilities, and create a more welcoming environment for foreign students.</p>
                                </div>
                            </div>
                            <div>
                                <div className="uk-card uk-card-body">
                                    <h3 className="uk-card-title">Expanding Scholarship Access</h3>
                                    <p>To attract top talent, Kazakhstan offers numerous state-funded scholarships. For the 2025-2026 academic year, 550 scholarships were approved for foreign citizens through programs administered by the Center for International Programs ("Bolashak"), reducing financial barriers to quality education.</p>
                                </div>
                            </div>
                            <div>
                                <div className="uk-card uk-card-body">
                                    <h3 className="uk-card-title">A Diverse Student Body</h3>
                                    <p>The country is seeing a significant shift in student origins, with a growing influx from South and Central Asia. This creates a diverse, multicultural campus experience that enriches learning and builds global networks.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="uk-section uk-container">
                    <h2 className="uk-h2 uk-text-bold uk-text-center">Why Choose Jai International?</h2>
                    <p className="uk-text-lead uk-text-center">We don't just process visas. We build your bridge to a successful academic future in Kazakhstan.</p>
                    <div className="uk-child-width-1-3@m uk-grid-match uk-margin-medium-top" data-uk-grid>
                        <div>
                            <div className="uk-card uk-card-body uk-text-center">
                                <span data-uk-icon="icon: check; ratio: 3" className="uk-text-success"></span>
                                <h3 className="uk-card-title uk-margin-top">Expert Guidance</h3>
                                <p>Our team has deep knowledge of the Kazakhstani education system and visa laws, including the latest November 2024 rule changes, ensuring your application is accurate and efficient.</p>
                            </div>
                        </div>
                        <div>
                            <div className="uk-card uk-card-body uk-text-center">
                                <span data-uk-icon="icon: heart; ratio: 3" className="uk-text-danger"></span>
                                <h3 className="uk-card-title uk-margin-top">University Partnerships</h3>
                                <p>Our direct partnerships with leading universities streamline your admission process, giving you an edge and access to the best available programs.</p>
                            </div>
                        </div>
                        <div>
                            <div className="uk-card uk-card-body uk-text-center">
                                <span data-uk-icon="icon: happy; ratio: 3" className="uk-text-primary"></span>
                                <h3 className="uk-card-title uk-margin-top">End-to-End Support</h3>
                                <p>From your first inquiry to your arrival and registration in Kazakhstan, we provide continuous support to make your transition smooth and stress-free.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="uk-section uk-container">
                    <h2 className="uk-h2 uk-text-bold uk-text-center">Our Partner Universities</h2>
                    <p className="uk-text-lead uk-text-center uk-margin-medium-bottom">We have established strong ties with Kazakhstan's leading universities to ensure a smooth and prioritized admission process for our clients.</p>
                    <div className="uk-child-width-1-2@s uk-child-width-1-3@m uk-grid-match" data-uk-grid="masonry: true">
                        {partners.map(partner => (
                            <div key={partner.id}>
                                <div className="uk-card uk-card-default uk-card-hover">
                                    <div className="uk-card-media-top uk-flex uk-flex-center uk-padding-small" style={{ backgroundColor: '#f9f9f9' }}>
                                        <img src={partner.logoUrl} alt={`${partner.name} Logo`} style={{ height: '80px', objectFit: 'contain' }} />
                                    </div>
                                    <div className="uk-card-body">
                                        <h3 className="uk-card-title uk-margin-remove-top">{partner.name}</h3>
                                        <p className="uk-margin-small-top">{partner.description}</p>
                                    </div>
                                    <div className="uk-card-footer">
                                        <a href={partner.websiteUrl} target="_blank" rel="noopener noreferrer" className="uk-button uk-button-text">
                                            Visit University <span data-uk-icon="arrow-right"></span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                 <div className="uk-section uk-container">
                    <h2 className="uk-h2 uk-text-bold uk-text-center">Your Journey to a Kazakhstani University</h2>
                     <p className="uk-text-lead uk-text-center">We've simplified the path to studying in Kazakhstan into three clear steps.</p>
                     <div className="uk-child-width-1-3@m uk-grid-match uk-margin-medium-top" data-uk-grid>
                        <div>
                            <div className="uk-card uk-card-body uk-text-center">
                                <div className="uk-text-primary uk-h1 uk-text-bold">1</div>
                                <h3 className="uk-card-title">Consultation & University Selection</h3>
                                <p>We begin with a free, in-depth consultation to understand your academic background and career goals. Based on this, we help you select the perfect university and program from our network of partners.</p>
                            </div>
                        </div>
                        <div>
                            <div className="uk-card uk-card-body uk-text-center">
                                <div className="uk-text-primary uk-h1 uk-text-bold">2</div>
                                <h3 className="uk-card-title">Application & Admission</h3>
                                <p>Our meticulous team assists you in preparing and verifying all necessary documents, from transcripts to statements of purpose. We then manage the application submission to ensure it meets all deadlines and requirements, securing your official admission letter.</p>
                            </div>
                        </div>
                        <div>
                            <div className="uk-card uk-card-body uk-text-center">
                                <div className="uk-text-primary uk-h1 uk-text-bold">3</div>
                                <h3 className="uk-card-title">Visa & Arrival Support</h3>
                                <p>With the admission letter, we manage the entire C9 student visa process. We then ensure a smooth arrival with optional airport pickup and accommodation support, and crucially, we assist with the mandatory migration police registration to ensure your legal status is secured promptly.</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <ParallaxCallSection
                URL="/imgvideo/charyn.webp"
                headline="Ready to Begin Your Adventure?"
                onCallToActionClick={() => window.open("https://wa.me/77750912804?text=Hello%2C%20I%20want%20to%20study%20in%20Kazakhstan", "_blank")}
                callToAction="Contact a Jai Education Consultant Today"
            />

            <FaqAccordionsSection
                sectionTitle="Frequently Asked Questions"
                items={faqItems}
            />

            <FooterSection />
        </div>
    );
}

export default VisaStudyOverviewPage;
